import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { CommunityService } from '../../../api/services';
import { MediaItem } from '../../../api/models';

@Component({
  selector: 'app-modal-new-community',
  templateUrl: './modal-new-community.component.html',
  styleUrl: './modal-new-community.component.scss'
})
export class ModalNewCommunityComponent {

  imageChangedEvent: any = '';
  croppedImage: any = '';
  imageBlob?: Blob;
  img?: MediaItem;

  isUpdate = false;

  type: any[] = [
    { name: 'Aperto', value: true },
    { name: 'Chiuso', value: false }
  ];

  frmComm: FormGroup = new FormGroup({
    name: new FormControl('', Validators.required),
    public: new FormControl<boolean>(true, Validators.required),
    tags: new FormControl<string[]>([]),
    text: new FormControl(''),
  })

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private sanitizer: DomSanitizer,
    private communityService: CommunityService
  ) {
    if (config.data!.initial_value) {
      this.isUpdate = true;
      this.communityService.communityControllerGetOne({id: config.data!.initial_value.id}).subscribe({
        next: (res) => {
          this.frmComm.get('name')?.patchValue(res.data.name);
          this.frmComm.get('public')?.patchValue(res.data.public);
          this.frmComm.get('tags')?.patchValue(res.data.tags);
          this.frmComm.get('text')?.patchValue(res.data.text);

          this.img = res.data.picture
        }
      })
      
    }
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(
      (event).objectUrl!
    );
    this.imageBlob = event.blob!
    // event.blob can be used to upload the cropped image
  }
  imageLoaded(image: LoadedImage) {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  close() {
    this.ref.close();
  }

  save(){
    const frm = this.frmComm.value;
    this.ref.close({frm: this.frmComm.value, picture: this.imageBlob})
  }

}
